import PropTypes from "prop-types";
import React from "react";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import { decodeText } from "../../../utils/richText";

const FooterCampaign = ({ node }) => {
    if (!node?.title) return null;

    const label = decodeText(node.link?.label);

    return (
        <div className="footer-campaign">
            <div className="container footer-campaign__inner">
                <div className="footer-campaign__content">
                    <strong className="footer-campaign__title">{decodeText(node.title)}</strong>
                    {node.text && <p className="footer-campaign__text">{decodeText(node.text)}</p>}
                </div>
                {label && (
                    <div className="btn-hover">
                        <LinkWrapper linkNode={node.link} linkClass="default-btn rounden-btn footer-campaign__cta">
                            {label}
                            <span aria-hidden="true">&rarr;</span>
                        </LinkWrapper>
                    </div>
                )}
            </div>
        </div>
    );
};

FooterCampaign.propTypes = {
    node: PropTypes.object,
};

export default FooterCampaign;
